var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71 7.7l-4.59 4.59 4.59 4.59-1.42 1.41-6-6 6-6L9.71 7.7z"
  })));
}

export default "/images/left.svg?3ad4a83a8d3108b9b3cd9a3ff43fa35b";
export { SvgLeft as ReactComponent };